import { useEffect, useState } from "react";
import { CalendarDays, Clock3, MapPin, UserRound } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export const TodayBookingsSummary = () => {
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!user || !["teacher", "technician"].includes(user.role)) return;
    api
      .get("/home/today-bookings")
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]));
  }, [user]);

  if (!items?.length) return null;
  const technician = user.role === "technician";
  return (
    <section className="mt-7" data-testid="today-bookings-summary">
      <div className="mb-3 flex items-center gap-2">
        <CalendarDays className="h-4 w-4 text-primary" />
        <h2 className="text-base font-semibold" data-testid="today-bookings-heading">
          Today&apos;s practicals
        </h2>
      </div>
      <div className="grid gap-2 sm:grid-cols-2" data-testid="today-bookings-list">
        {items.map((item) => (
          <Link
            key={item.id}
            className="rise flex min-w-0 items-center gap-3 rounded-lg border bg-card px-3 py-3 shadow-sm transition-colors hover:border-primary/60"
            to={technician ? `/prep?booking=${item.id}` : "/bookings"}
            data-testid={`today-booking-${item.id}`}
          >
            <Clock3 className="h-4 w-4 shrink-0 text-primary" />
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold" data-testid={`today-booking-name-${item.id}`}>
                {item.practical_name}
              </p>
              <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
                <span className="inline-flex items-center gap-1">
                  <MapPin className="h-3 w-3" />
                  {item.lab || "No lab"}
                </span>
                <span>Period {item.period}</span>
                {technician && (
                  <span className="inline-flex items-center gap-1">
                    <UserRound className="h-3 w-3" />
                    {item.teacher_name}
                  </span>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};